module.exports = __webpack_public_path__ + "static/media/drive.6743a720.svg";